import axios from 'axios'
import date from 'quasar/src/utils/date/date.js';;


class Fetcher {
    config = require('../config')

    StudyLevelQueryAttributes = [
        "0020000D", //StudyUID
        "00200010", //StudyID
        "00100010", //Patient Name
        "00100020", //Patient ID
        "00100030", //Patient DOB
        "00100040", //Patient Sex
        "00080020", //Study Date
        "00080030", //Study Time
        "00081030", //Study Description
        "00080050", //Accession Number
        "00080061", //Modalities in Study
        "00201208", //Number of Study Related Instances
    ];

    SeriesLevelQueryAttributes = [
        "0020000E", //Series UID
        "00080060", //Modality
        "0008103E", //Series Description
        "00200011", //Series Number
        "00080021", //Series Date
        "00201209", //Number of Series Related Instances
        "00200052", //Frame of Reference UID
    ];


    SearchAttributes = {
        "patientName": "00100010",
        "patientID": "00100020",
        "studyDate": "00080020",
        "studyDescription": "00081030",
        "modalities": "00080061"
    };

    InstanceLevelQueryAttributes = [
        "00080016", //SOP Class UID
        "00080018", //Instance UID
    ]

    async FetchStudyTable(limit, offset, filter) {
        // -------------------------- Create URL --------------------------
        var studyQidoQuery = `${this.config.baseUrl}/${this.config.qido.root}/studies?limit=${limit}&offset=${offset}`;

        // Add filter (if applicable), includefield to URL
        for (let index = 0; index < this.StudyLevelQueryAttributes.length; index++) {
            const attribute = this.StudyLevelQueryAttributes[index];

            var search = '';
            if (filter != undefined) {
                var filterKeys = Object.keys(filter);
                if (filterKeys.length > 0) {
                    for (let s = 0; s < filterKeys.length; s++) {
                        if (attribute == this.SearchAttributes[Object.keys(filter)[s]]) {
                            search = Object.keys(filter)[s];
                            break;
                        }
                    }
                }
            }

            if (filter != undefined && search.length > 0) {
                if (attribute == "00080020") { //study date
                    var today = new Date();
                    const filterDate = date.subtractFromDate(today, { days: filter[search] });
                    studyQidoQuery = studyQidoQuery.concat(`&${attribute}=${date.formatDate(filterDate, 'YYYYMMDD')}-${date.formatDate(today, 'YYYYMMDD')}`);
                } else if (attribute == "00080061") {
                    studyQidoQuery = studyQidoQuery.concat(`&${attribute}=${filter[search]}`);
                } else {
                    studyQidoQuery = studyQidoQuery.concat(`&${attribute}=*${filter[search]}*`);
                }
            } else {
                studyQidoQuery = studyQidoQuery.concat(`&includefield=${attribute}`);
            }
        }

        // -------------------------- Retrieve data -------------------------- 
        const studiesData = await axios.get(studyQidoQuery);

        var studies = [];
        for (let i = 0; i < studiesData.data.length; i++) {
            if (studiesData.data[i]["0020000D"].Value != undefined) {
                var series = await this.FetchSeriesDataQido(studiesData.data[i]["0020000D"].Value[0])

                var imageCount = 0

                for (let s = 0; s < series.length; s++) {
                    imageCount += series[s].instanceCount
                }

                studies.push({
                    studyUID: studiesData.data[i]["0020000D"] != undefined && studiesData.data[i]["0020000D"].Value != undefined ?
                        studiesData.data[i]["0020000D"].Value[0] : "",
                    studyID: studiesData.data[i]["00200010"] != undefined && studiesData.data[i]["00200010"].Value != undefined ?
                        studiesData.data[i]["00200010"].Value[0] : "",
                    patientName: studiesData.data[i]["00100010"] != undefined && studiesData.data[i]["00100010"].Value != undefined ?
                        studiesData.data[i]["00100010"].Value[0]["Alphabetic"] : "",
                    patientID: studiesData.data[i]["00100020"] != undefined && studiesData.data[i]["00100020"].Value != undefined ?
                        studiesData.data[i]["00100020"].Value[0] : "",
                    patientDOB: studiesData.data[i]["00100030"] != undefined && studiesData.data[i]["00100030"].Value != undefined ?
                        studiesData.data[i]["00100030"].Value[0] : "",
                    patientSex: studiesData.data[i]["00100040"] != undefined && studiesData.data[i]["00100040"].Value != undefined ?
                        studiesData.data[i]["00100040"].Value[0] : "",
                    studyDate: studiesData.data[i]["00080020"] != undefined && studiesData.data[i]["00080020"].Value != undefined ?
                        studiesData.data[i]["00080020"].Value[0] : "",
                    studyTime: studiesData.data[i]["00080030"] != undefined && studiesData.data[i]["00080030"].Value != undefined ?
                        studiesData.data[i]["00080030"].Value[0] : "",
                    studyDescription: studiesData.data[i]["00081030"].Value != undefined && studiesData.data[i]["00081030"].Value != undefined ?
                        studiesData.data[i]["00081030"].Value[0] : "",
                    accessionNumber: studiesData.data[i]["00080050"] != undefined && studiesData.data[i]["00080050"].Value != undefined ?
                        studiesData.data[i]["00080050"].Value[0] : "",
                    modalities: studiesData.data[i]["00080061"] != undefined && studiesData.data[i]["00080061"].Value != undefined ?
                        studiesData.data[i]["00080061"].Value.join('/') : "",
                    imageCount: studiesData.data[i]["00201208"] != undefined && studiesData.data[i]["00201208"].Value != undefined ?
                        studiesData.data[i]["00201208"].Value[0] : imageCount,
                    series: series,
                });
            }
        }

        return studies
    }

    async FetchSeriesDataQido(studyUID) {
        var series = [];

        var seriesQidoQuery = `${this.config.baseUrl}/${this.config.qido.root}/studies/${studyUID}/series`;

        for (let index = 0; index < this.SeriesLevelQueryAttributes.length; index++) {
            const attribute = this.SeriesLevelQueryAttributes[index];
            seriesQidoQuery = seriesQidoQuery.concat(
                (index === 0 ? "?" : "&") + `includefield=${attribute}`
            );
        }

        const seriesForStudy = await axios.get(seriesQidoQuery);

        for (let index = 0; index < seriesForStudy.data.length; index++) {
            const tempseries = seriesForStudy.data[index];

            var seriesUID = (tempseries["0020000E"] != undefined && tempseries["0020000E"].Value != undefined) ? tempseries["0020000E"].Value[0] : ""

            var instanceQidoQuery = `${this.config.baseUrl}/${this.config.qido.root}/studies/${studyUID}/series/${seriesUID}/instances?includefield=00080018`

            var instancesForSeries = await axios.get(instanceQidoQuery)

            var instanceCount = instancesForSeries.data != undefined ? instancesForSeries.data.length : 0

            series.push({
                seriesUID: tempseries["0020000E"] != undefined && tempseries["0020000E"].Value != undefined ?
                    tempseries["0020000E"].Value[0] : "",
                modality: tempseries["00080060"] != undefined && tempseries["00080060"].Value != undefined ?
                    tempseries["00080060"].Value[0] : "",
                seriesDescription: tempseries["0008103E"] != undefined && tempseries["0008103E"].Value != undefined ?
                    tempseries["0008103E"].Value[0] : "",
                seriesNumber: tempseries["00200011"] != undefined && tempseries["00200011"].Value != undefined ?
                    tempseries["00200011"].Value[0] : "",
                seriesDate: tempseries["00080021"] != undefined && tempseries["00080021"].Value != undefined ?
                    tempseries["00080021"].Value[0] : "",
                instanceCount: tempseries["00201209"] != undefined && tempseries["00201209"].Value != undefined ?
                    tempseries["00201209"].Value[0] : "",
                instanceCount: instanceCount
            });
        }
        return series
    }

    // Previously FetchStudyData
    async FetchAllStudies(limit, offset, toSeriesLevel, toInstanceLevel, filter) {

        // ------------------------------  Generate QIDO query URL --------------------------------- //
        //1. baseURL
        var studyQidoQuery = `${this.config.baseUrl}/${this.config.qido.root}/studies`;

        //2. add limit and offset
        studyQidoQuery = studyQidoQuery.concat(
            `?limit=${limit}&offset=${offset}`
        );

        //3. add attributes to the query string
        for (let index = 0; index < this.StudyLevelQueryAttributes.length; index++) {
            const attribute = this.StudyLevelQueryAttributes[index];

            var search = '';
            if (filter != undefined) {
                var filterKeys = Object.keys(filter);
                if (filterKeys.length > 0) {
                    for (let s = 0; s < filterKeys.length; s++) {
                        if (attribute == this.SearchAttributes[Object.keys(filter)[s]]) {
                            search = Object.keys(filter)[s];
                            break;
                        }
                    }
                }
            }

            if (filter != undefined && search.length > 0) {
                if (attribute == "00080020") { //study date
                    var today = new Date();
                    const filterDate = date.subtractFromDate(today, { days: filter[search] });
                    studyQidoQuery = studyQidoQuery.concat(`&${attribute}=${date.formatDate(filterDate, 'YYYYMMDD')}-${date.formatDate(today, 'YYYYMMDD')}`);
                } else if (attribute == "00080061") {
                    studyQidoQuery = studyQidoQuery.concat(`&${attribute}=${filter[search]}`);
                } else {
                    studyQidoQuery = studyQidoQuery.concat(`&${attribute}=*${filter[search]}*`);
                }
            } else {
                studyQidoQuery = studyQidoQuery.concat(`&includefield=${attribute}`);
            }

        }

        // ------------------------------   Get data from Dicom Web Server --------------------------------- //
        //1. Qido study query
        const studiesData = await axios.get(studyQidoQuery);

        //2. Convert study data to make it work with the table
        var studies = [];
        for (let i = 0; i < studiesData.data.length; i++) {
            if (studiesData.data[i]["0020000D"].Value != undefined) {
                //3. Qido series query
                var series = []

                if (toSeriesLevel)
                    series = await this.FetchSeriesData(studiesData.data[i]["0020000D"].Value[0], toInstanceLevel)

                studies.push({
                    studyUID: studiesData.data[i]["0020000D"] != undefined && studiesData.data[i]["0020000D"].Value != undefined ?
                        studiesData.data[i]["0020000D"].Value[0] : "",
                    studyID: studiesData.data[i]["00200010"] != undefined && studiesData.data[i]["00200010"].Value != undefined ?
                        studiesData.data[i]["00200010"].Value[0] : "",
                    patientName: studiesData.data[i]["00100010"] != undefined && studiesData.data[i]["00100010"].Value != undefined ?
                        studiesData.data[i]["00100010"].Value[0]["Alphabetic"] : "",
                    patientID: studiesData.data[i]["00100020"] != undefined && studiesData.data[i]["00100020"].Value != undefined ?
                        studiesData.data[i]["00100020"].Value[0] : "",
                    patientDOB: studiesData.data[i]["00100030"] != undefined && studiesData.data[i]["00100030"].Value != undefined ?
                        studiesData.data[i]["00100030"].Value[0] : "",
                    patientSex: studiesData.data[i]["00100040"] != undefined && studiesData.data[i]["00100040"].Value != undefined ?
                        studiesData.data[i]["00100040"].Value[0] : "",
                    studyDate: studiesData.data[i]["00080020"] != undefined && studiesData.data[i]["00080020"].Value != undefined ?
                        studiesData.data[i]["00080020"].Value[0] : "",
                    studyTime: studiesData.data[i]["00080030"] != undefined && studiesData.data[i]["00080030"].Value != undefined ?
                        studiesData.data[i]["00080030"].Value[0] : "",
                    studyDescription: studiesData.data[i]["00081030"].Value != undefined && studiesData.data[i]["00081030"].Value != undefined ?
                        studiesData.data[i]["00081030"].Value[0] : "",
                    accessionNumber: studiesData.data[i]["00080050"] != undefined && studiesData.data[i]["00080050"].Value != undefined ?
                        studiesData.data[i]["00080050"].Value[0] : "",
                    modalities: studiesData.data[i]["00080061"] != undefined && studiesData.data[i]["00080061"].Value != undefined ?
                        studiesData.data[i]["00080061"].Value.join('/') : "",
                    imageCount: studiesData.data[i]["00201208"] != undefined && studiesData.data[i]["00201208"].Value != undefined ?
                        studiesData.data[i]["00201208"].Value[0] : "",
                    series: series,
                });
            }
        }

        return studies
    }

    async FetchStudyData(studyUID, toSeriesLevel, toInstanceLevel) {
        var study = []
        var studyQidoQuery = `${this.config.baseUrl}/${this.config.qido.root}/studies?0020000D=${studyUID}`;

        for (let index = 0; index < this.StudyLevelQueryAttributes.length; index++) {
            const attr = this.StudyLevelQueryAttributes[index]
            if (!studyQidoQuery.includes(attr))
                studyQidoQuery = studyQidoQuery.concat(`&includefield=${attr}`)
        }

        var startTime = performance.now()
        const studyQidoData = await axios.get(studyQidoQuery).then(function (res) { return res.data[0] });
        var endTime = performance.now()
        console.log(`Study QIDO completed in ${((endTime - startTime) / 1000).toFixed(2)}s`)

        if (studyQidoData["0020000D"].Value != undefined) {
            //3. Qido series query
            var series = []


            if (toSeriesLevel)
                series = await this.FetchSeriesData(studyQidoData["0020000D"].Value[0], toInstanceLevel)

            study.push({
                studyUID: this.GetValue(studyQidoData, "0020000D"),
                studyID: this.GetValue(studyQidoData, "00200010"),
                patientName: this.GetValue(studyQidoData, "00100010"),
                patientID: this.GetValue(studyQidoData, "00100020"),
                patientDOB: this.GetValue(studyQidoData, "00100030"),
                patientSex: this.GetValue(studyQidoData, "00100040"),
                studyDate: this.GetValue(studyQidoData, "00080020"),
                studyTime: this.GetValue(studyQidoData, "00080030"),
                studyDescription: this.GetValue(studyQidoData, "00081030"),
                accessionNumber: this.GetValue(studyQidoData, "00080050"),
                modalities: this.GetValue(studyQidoData, "00080061"),
                imageCount: this.GetValue(studyQidoData, "00201208"),
                series: series,
            });
        }
        return study;
    }

    async FetchSeriesData(studyUID, toInstanceLevel) {
        var series = [];
        var seriesQidoQuery = `${this.config.baseUrl}/${this.config.qido.root}/studies/${studyUID}/series?includefield=0020000E`;

        const seriesForStudy = await axios.get(seriesQidoQuery);

        for (let index = 0; index < seriesForStudy.data.length; index++) {
            const seriesData = seriesForStudy.data[index];
            var instances = []
            var startTime = performance.now()

            if (toInstanceLevel) {
                instances = await this.FetchInstanceData(studyUID, seriesData["0020000E"].Value[0])
            }

            var endTime = performance.now()
            console.log(`FetchInstanceData completed in ${((endTime - startTime) / 1000).toFixed(2)}s`)

            series.push({
                seriesUID: this.GetValue(seriesData, "0020000E"),
                modality: this.GetValue(seriesData, "00080060"),
                seriesDescription: this.GetValue(seriesData, "0008103E"),
                seriesNumber: this.GetValue(seriesData, "00200011"),
                seriesDate: this.GetValue(seriesData, "00080021"),
                instanceCount: this.GetValue(seriesData, "00201209"),
                frameOfReferenceUID: this.GetValue(seriesData, "00200052"),
                instances: instances
            });
        }

        return series
    }

    async FetchInstanceData(studyUID, seriesUID) {
        var instances = []
        var instanceQidoQuery = `${this.config.baseUrl}/${this.config.qido.root}/studies/${studyUID}/series/${seriesUID}/instances?includefield=00080018&includefield=00080016`

        var instancesForSeries = await axios.get(instanceQidoQuery)

        for (let inst = 0; inst < instancesForSeries.data.length; inst++) {
            const tempInst = instancesForSeries.data[inst];

            instances.push({
                instanceUID: tempInst["00080018"] != undefined && tempInst["00080018"].Value != undefined ?
                    tempInst["00080018"].Value[0] : "",
                sopClassUID: tempInst["00080016"] != undefined && tempInst["00080016"].Value != undefined ?
                    tempInst["00080016"].Value[0] : "",
            })
        }
        return instances
    }

    GetValue(dataset, tag) {
        if (dataset[tag] != undefined && dataset[tag].Value != undefined) {
            var result = dataset[tag].Value.length > 1 ?
                dataset[tag].Value.join('/ ')
                : dataset[tag].Value[0];
            
            if (dataset[tag].vr == 'PN')
                result = result.Alphabetic

            return result
        }
        else
            return ""
    }
}

export default Fetcher